var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInTransitContainers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160.302,
    height: 111.5,
    viewBox: "0 0 160.302 111.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_20",
    "data-name": "Union 20",
    d: "M113.1,92.183v-3.1h6.972v3.1a11.62,11.62,0,1,0,23.239,0v-3.1h6.972v3.1c-1.549,10.071-9.3,17.817-19.366,17.817A17.53,17.53,0,0,1,113.1,92.183Zm-99.154,0v-3.1h6.972v3.1a11.914,11.914,0,0,0,11.62,11.62,11.914,11.914,0,0,0,11.62-11.62v-3.1h6.2v3.1C49.577,102.254,41.831,110,31.761,110A17.53,17.53,0,0,1,13.944,92.183Zm137.887,3.873V89.085H155.7v6.972Zm-96.056,0V89.085h50.352v6.972Zm-52.676,0V89.085h7.746v6.972ZM116.2,82.887H3.1a3.332,3.332,0,0,1-3.1-3.1V3.1A2.837,2.837,0,0,1,3.1,0H116.2a3.332,3.332,0,0,1,3.1,3.1V18.591H155.7a3.333,3.333,0,0,1,3.1,3.1V79.014c0,2.324-1.549,3.873-3.1,3.873Zm3.873-6.972h32.535V50.352H134.014a3.332,3.332,0,0,1-3.1-3.1V25.564H120.071ZM6.2,75.916H113.1V6.2H6.2Zm131.69-31.761h14.719V25.564H137.887ZM71.268,65.071q-2.324-2.325,0-4.648l6.2-6.2H53.45a3.1,3.1,0,0,1,0-6.2H77.941l-5.9-6.972c-1.549-.775-1.549-3.1,0-4.648s3.1-1.549,4.647,0L90.634,50.352,88.978,52.1a2.578,2.578,0,0,1-1.869,1.973l-10.42,11c-.774.774-1.549.774-3.1.774A2.847,2.847,0,0,1,71.268,65.071Zm67.394-1.55V56.55h6.2v6.972ZM43.381,45.7,32.126,33.825a2.522,2.522,0,0,1-1.818-1.919l-.871-.919.968-.968a3.565,3.565,0,0,1,1.937-1.937L43.381,17.042q2.324-2.324,4.647,0t0,4.648l-6.2,6.2H65.845a3.332,3.332,0,0,1,3.1,3.1,2.838,2.838,0,0,1-3.1,3.1H41.831l6.2,6.2q2.325,2.325,0,4.648c-.774,1.549-1.549,1.549-2.323,1.549A2.845,2.845,0,0,1,43.381,45.7Z",
    transform: "translate(0.75 0.75)",
    fill: "#0671ff",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTransitContainers);
export default __webpack_public_path__ + "static/media/InTransitContainers.6a3aea7dd4fc3ee8f32f2d913c017853.svg";
export { ForwardRef as ReactComponent };